module.exports = __webpack_public_path__ + "static/media/rio2@2x.eb2f6277.png";